import i18n from '../i18n'

export const Initialize = () => {
    return new Promise((resolve, reject) => {
        var a = navigator.userAgent || navigator.vendor || window.opera
        var isMobile = (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4)))

        if (isMobile === false) { //아이패드 체크
            isMobile = navigator.userAgent.match(/iPad/i) != null
        }

        window.channelPluginSettings = {
            "pluginKey": "4eae15fa-9ad0-4a7d-b931-1d05f303d8fc", // Videomonster
            "mobileOpenUI": "iframe"
        }

        const { search } = window.location
        if ((typeof search === 'string' && search.toLowerCase().includes('provider=vchange')) || sessionStorage.getItem("provider") === 'vchange') {
            window.channelPluginSettings.pluginKey = "edad1463-005f-460f-95ee-810ef34b7bb1" // Vchnage
        }

        if ((typeof search === 'string' && search.toLowerCase().includes('provider=cafe24')) || sessionStorage.getItem("provider") === 'cafe24') {
            window.channelPluginSettings.pluginKey = "721f6bba-26b0-4a79-bf1f-08e79965ac8c" // cafe24
        }

        if ((typeof search === 'string' && search.toLowerCase().includes('provider=video09')) || sessionStorage.getItem("provider") === 'video09') {
            window.channelPluginSettings.pluginKey = "5fc7a630-828e-412c-a48c-d650d78256ae" // cafe24
        }

        var w = window
        if (w.ChannelIO || window.location.pathname.startsWith('/admin')) return resolve()
        if (window.location.pathname.startsWith('/admin')) return resolve()

        var d = window.document
        var ch = function () {
            ch.c(arguments)
        }
        ch.q = []
        ch.c = function (args) {
            ch.q.push(args)
        }
        w.ChannelIO = ch
        function l() {
            if (w.ChannelIOInitialized) return resolve()
            w.ChannelIOInitialized = true
            var s = document.createElement('script')
            s.id = 'channel-io-script'
            s.type = 'text/javascript'
            s.async = true
            s.src = 'https://cdn.channel.io/plugin/ch-plugin-web.js'
            s.charset = 'UTF-8'
            document.body.appendChild(s)

            s.addEventListener('load', function () {
                resolve()
            })
            s.addEventListener('error', function (e) {
                reject(e)
            })
        }
        if (document.readyState === 'complete') {
            l()
        } else if (window.attachEvent) {
            window.attachEvent('onload', l)
        } else {
            window.addEventListener('DOMContentLoaded', l, false)
            window.addEventListener('load', l, false)
        }
    })
}

let channelIOProfile = {}
export const Boot = profile => {
    if (!window.ChannelIO || !profile) return

    const {
        _id,
        userId,
        email,
        type
    } = profile

    channelIOProfile = {
        _id,
        name: userId,
        email,
        type,
        isApp: false
    }

    window.ChannelIO('boot', {
        ...window.channelPluginSettings,
        locale: i18n.language,
        memberId: _id,
        profile: channelIOProfile
    }, function (error, user) { })
}

export const AddProfileKey = param => {
    if (!window.ChannelIO) return

    const profile = JSON.parse(JSON.stringify(channelIOProfile))
    Object.keys(param).forEach(key => profile[key] = param[key])

    window.ChannelIO('updateUser', {
        language: i18n.language,
        tags: null,
        profile,
        profileOnce: profile,
        unsubscribed: false
    }, function (error, user) { })
}

export const Shutdown = () => {
    if (!window.ChannelIO) return

    var s = document.getElementById('channel-io-script')
    if (s) document.body.removeChild(s)

    var div = document.getElementById('ch-plugin')
    if (div) document.body.removeChild(div)

    window.ChannelIOInitialized = false
    window.ChannelIO = null
}